import { useRoutes as useRoutesBase } from 'react-router-dom';
import { ORDER_LIST_ROUTES, ORDER_ROUTES, REPORT_ROUTES } from './constants';

export const useRoutes = () => {
  const routes = useRoutesBase([
    ...ORDER_LIST_ROUTES,
    ...REPORT_ROUTES,
    ...ORDER_ROUTES,
    {
      path: '*',
      element: <p>404 does not exist</p>,
    },
  ]);

  return routes;
};
